module.exports = __webpack_public_path__ + "static/img/cont33_01.459c1a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont33_01.jpg
// module id = 4LWE
// module chunks = 0